import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useShallowEqualSelector } from '@hooks';
import { getAuthToken } from '@dotone/react-ui-core/utils';
import { Container } from 'reactstrap';
import { FlexContainer, LoaderContainer, Footer } from '@dotone/react-ui-core';
import NavbarPublic from './NavbarPublic';
import LayoutProtected from './LayoutProtected';

const paramsThatMatter = [
  'sourceid',
  'subid',
  'vtm_stat_id',
  'channel_id',
  'campaign_id',
  'campaign_locale',
];

const LayoutPublic = ({
  title,
  navProps,
  loading,
  children,
  flexible = false,
  breadcrumbsHidden,
  ...otherProps
}) => {
  const router = useRouter();
  const authToken = getAuthToken('network');

  const { isAuthenticated, redirectTo } = useShallowEqualSelector(({ auth }) => auth);

  useEffect(() => {
    if (!flexible && (isAuthenticated || authToken)) {
      router.push(redirectTo || '/advertisers');
    }
  }, [router, isAuthenticated, redirectTo, flexible, authToken]);

  useEffect(() => {
    const checkVA = setInterval(() => {
      if (typeof window !== 'undefined' && window.VA) {
        clearInterval(checkVA);

        paramsThatMatter.forEach(function (key) {
          if (window.VA.qs[key]) {
            window.VA.createCookie(key, window.VA.qs[key], 90, '/', '.affiliates.one');
          }
        });

        try {
          window.VA.remoteLoad({
            whiteLabel: { id: 8, siteId: 1545, domain: 't.adotone.com' },
            locale: 'en-US',
            mkt: true,
          });
        } catch (err) {
          console.log('Referral tracking is unavailable');
        }
      }
    }, 100);

    return () => {
      clearInterval(checkVA);
    };
  }, []);

  return flexible && (isAuthenticated || authToken) ? (
    <LayoutProtected
      title={title}
      loading={loading}
      breadcrumbsHidden={breadcrumbsHidden}
      {...otherProps}
    >
      {children}
    </LayoutProtected>
  ) : (
    <>
      <Head>
        <title>Affiliates.One{title && ` - ${title}`}</title>
        <script defer src="https://cdn.adotone.com/javascripts/va.js" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {!isAuthenticated && (
        <>
          <NavbarPublic {...navProps} />
          <FlexContainer className="flex-grow-1" align="center" justify="center">
            <LoaderContainer loading={loading}>
              <Container fluid className="py-4" {...otherProps}>
                {children}
              </Container>
            </LoaderContainer>
          </FlexContainer>
          <Footer className="text-center p-3" />
        </>
      )}
      {isAuthenticated && <LoaderContainer loading />}
    </>
  );
};

export default LayoutPublic;
